export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11134.9452576a.jpg";